export function seconds(n: number) {
	return n * 1000
}
